const autoClickerData = {
  name: "Safe Auto Clicker — Smart Mouse Click Automation for Any Website",
  description:
    "A user-initiated auto clicker UI for any website. No data is collected or sent anywhere. All actions are performed locally in your browser, ensuring your privacy and security.",
  label: "How to Use",
  usage: [
    "Click the extension icon and enable the auto clicker panel.",
    "Click 🎯 Select Target and then click any element on the page.",
    "Enter a timer that is convenient for you.",
    "Click ▶️ Start to begin auto-clicking. To stop, click ⏹️ Stop.",
    "You can drag the panel, hide it, or reset all data anytime.",
    "Your settings are saved automatically between sessions.",
  ],
  btnBack: "Back",
};

export default autoClickerData;
